/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffOverviewEntry } from './StaffOverviewEntry';
import {
    StaffOverviewEntryFromJSON,
    StaffOverviewEntryFromJSONTyped,
    StaffOverviewEntryToJSON,
    StaffOverviewEntryToJSONTyped,
} from './StaffOverviewEntry';

/**
 * 
 * @export
 * @interface UsersFindAllResponse
 */
export interface UsersFindAllResponse {
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    data: Array<StaffOverviewEntry>;
}

/**
 * Check if a given object implements the UsersFindAllResponse interface.
 */
export function instanceOfUsersFindAllResponse(value: object): value is UsersFindAllResponse {
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UsersFindAllResponseFromJSON(json: any): UsersFindAllResponse {
    return UsersFindAllResponseFromJSONTyped(json, false);
}

export function UsersFindAllResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersFindAllResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'total': json['total'],
        'data': ((json['data'] as Array<any>).map(StaffOverviewEntryFromJSON)),
    };
}

export function UsersFindAllResponseToJSON(json: any): UsersFindAllResponse {
    return UsersFindAllResponseToJSONTyped(json, false);
}

export function UsersFindAllResponseToJSONTyped(value?: UsersFindAllResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
        'total': value['total'],
        'data': ((value['data'] as Array<any>).map(StaffOverviewEntryToJSON)),
    };
}

